import getApi from '../../../api/apisauceConfig'
import { ServerSentNotification } from '../../../model/Notification'

export const publishNotification = (id: string) =>
  getApi().post<ServerSentNotification>(`/admin/notifications/${id}/publish`)
